import { render, staticRenderFns } from "./RenderImg.vue?vue&type=template&id=cf0b0fb6"
import script from "./RenderImg.vue?vue&type=script&lang=js"
export * from "./RenderImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports